import React, { useEffect, useState } from "react";

import { Space } from "antd";
import TimeLockOption from "./parts/TimeLockOption/TimeLockOption";
import { FormikProps } from "formik";
import FundsService from "@services/Funds.service";
import { formatNumberToUSD } from "@features/utils/functions";
import { DEFAULT_TIMELOCK_STAKING_MIN_VALUE } from "@bundles/consts";

import * as styles from "./TimelockStakingStyle.module.scss";

export const TimeLockOptions = {
  none: {
    title: "No timelock",
    rewardFee: 20,
    custodyFee: "0,2% / Month",
    taxSubscription: "No",
    timelockDuration: null,
  },
  "1year": {
    title: "1 year timelock",
    rewardFee: 19,
    custodyFee: "0,18% / Month",
    taxSubscription: "Yes*",
    timelockDuration: 1,
  },
  "2year": {
    title: "2 years timelock",
    rewardFee: 18,
    custodyFee: "0,16% / Month",
    taxSubscription: "Yes*",
    timelockDuration: 2,
  },
  "3year": {
    title: "3 years timelock",
    rewardFee: 17,
    custodyFee: "0,14% / Month",
    taxSubscription: "Yes*",
    timelockDuration: 3,
  },
  "4year": {
    title: "4 years timelock",
    rewardFee: 16,
    custodyFee: "0,12% / Month",
    taxSubscription: "Yes*",
    timelockDuration: 4,
  },
  "5year": {
    title: "5 years timelock",
    rewardFee: 15,
    custodyFee: "0,10% / Month",
    taxSubscription: "Yes*",
    timelockDuration: 5,
  },
};

type Props = {
  formik: FormikProps<any>;
  displayNoTimeLock?: boolean;
  isUk?: boolean;
};

const TimeLockStaking = ({
  formik,
  displayNoTimeLock = false,
  isUk,
}: Props) => {
  const [minValue, setMinValue] = useState(DEFAULT_TIMELOCK_STAKING_MIN_VALUE);
  const onClick = async (selectedData: Record<string, number | null>) => {
    await formik.setValues({ ...formik.values, ...selectedData });
  };

  const { timelockDuration } = formik.values;

  useEffect(() => {
    FundsService.getTimelockStakingSettings().then((resp) => {
      setMinValue((prev) => resp?.data?.timelock_tier_threshold_amount ?? prev);
    });
  }, []);

  return (
    <div>
      <label className={styles.timeLockOptionLabel}>Timelock staking</label>
      <Space style={{ width: "100%", margin: "20px 0" }} direction="vertical">
        {Object.keys(TimeLockOptions)
          .filter((opt) => (displayNoTimeLock ? true : opt !== "none"))
          .map((key) => (
            <TimeLockOption
              {...TimeLockOptions[key as keyof typeof TimeLockOptions]}
              isUk={isUk}
              active={
                timelockDuration ===
                TimeLockOptions[key as keyof typeof TimeLockOptions]
                  .timelockDuration
              }
              minValue={minValue}
              onClick={onClick}
            />
          ))}
      </Space>
    </div>
  );
};

export default TimeLockStaking;
